export const SerbianTranslation = {
  companyName: "Coke loyalty",
  onlyOnMobViewing:
    "Aplikaciju je moguće koristiti samo na mobilnim ili tablet uredjajima.",
  onlyOnBigScreenViewing:
    "Molimo vas da aplikaciju otvorite na uredjaju sa većim ekranom.",
  login: {
    forgotPasswordExplanation: `Unesite email adresu koju ste koristili prilikom registracije kako
    bismo vam poslali link za promenu šifre.`,
    cancel: "Otkaži",
    send: "Pošalji",
    email: "Email",
    username: "Korisničko ime",
    password: "Šifra",
    forgotPasswordMessageSuccess:
      "Ukoliko je email validan, dobićete link za promenu šifre",
    forgotPassword: "Zaboravljena šifra?",
    login: "Uloguj se",
    noAccountWording: "Nemate korisnički nalog?",
    registerHere: "Registrujte se ovde",
    logOut: "Izloguj se",
  },
  signUp: {
    signUp: "Registrujte se",
    email: "Email",
    username: "Korisničko ime",
    password: "Šifra",
    confirmPassword: "Potvrdi šifru",
    phone: "Telefon",
    passwordConstraint:
      "Šifra mora da ima najmanje 8 karaktera uključujući slova i brojeve",
    passwordsNotMatchConstraint: "Šifre se ne poklapaju",
    phoneNumberValidConstraint: "Molimo unesite validan broj telefona",
    backToLogin: "Vratite se na login stranu",
    accept: "Prihvatam",
    termsAndConditions: "uslove korišćenja",
  },
  qrCodeScanner: {
    successReading: "Uspešno je očitan QR kod",
    uploadImageInfoText:
      "Ukoliko ne možete da skenirate QR kod sa računa, možete račun slikati i poslati!",
    send: "Pošalji",
    uploadImageExplanationText:
      "Molimo vas da čitko i jasno slikate ceo račun, važno je da se vide: naziv lokala, artikli, datum i QR kod. Nakon uspešnog slanja slike, osvojeni poeni će ubrzo biti dodati Vašim postojećim poenima.",
    uploadImage: "Učitaj sliku",
    sendImage: "Pošalji sliku",
    yourImage: "Vaša slika",
    remove: "Obriši",
    goBack: "Nazad",
    successReadingContent:
      "Uspešno ste očitali QR kod sa računa i ažurirani su vam poeni.",
  },
  pointsReview: {
    totalPoints: "Ukupno poena",
    productsAllowed: "Proizvodi i bodovi",
  },
  errors: {
    101: "Pogrešno korisničko ime/šifra",
    202: "Već postoji nalog kreiran sa ovim korisničkim imenom",
    203: "Već postoji nalog kreiran sa ovom email adresom",
    205: "Vaš email nije verifikovan, molimo vas da proverite vaš Inbox.",
    emailInvalid: "Email adresa nije validna",
    phoneNumberInvalid: "Broj telefona nije validan",
    requiredField: "Ovo polje je obavezno.",
    samePibError: "Već postoji lokal sa ovim PIB-om",
    invoiceNumberSubmitted: "Ovaj broj računa je već obradjen",
    404: "404",
    pageNotExist: "Stranica ne postoji",
    goHome: "Vrati se na početak",
    invalid_url: "Loš URL",
    already_validated: "Račun je već validiran",
    store_not_in_promotion: "Lokal ne učestvuje u promociji",
    qrCodeIsNotRead: "Račun nije uspešno očitan!",
  },
  profile: {
    profilePage: "Vaš profil",
    email: "Email",
    username: "Korisničko ime",
    phone: "Telefon",
    profilePic: "Profilna slika",
    chooseProfilePic: "Izaberite sliku",
    save: "Sačuvaj",
    cancel: "Otkaži",
    changeAvatar: "Promeni avatar",
    additionalQuestions:
      " U slučaju bilo kakvih problema ili dodatnih pitanja možete nas kontaktirati na sledeće email-ove:",
  },
  notifications: {
    successSavedData: "Uspešno sačuvani podaci",
    successOrderGift:
      "Uspešno ste naručili poklon. Proverite email inbox (junk)",
    successUploadImage: "Uspešno ste poslali sliku računa",
    notifications: "Upload nije uspeo molimo pokušajte ponovo",
    successDeletedGift: "Uspešno ste obrisali nagradu",
    successAddedNewGift: "Uspešno ste dodali novu nagradu",
    successEditGift: "Uspešno ste izmenili nagradu",
    successQRCodeRead: "Uspešno ste očitali QR kod i vaši bodovi su ažurirani",
    successUpdatedReceipt:
      "Uspešno ste ažurirali račun",
    successAddingNewProduct: "Uspešno ste dodali novi proizvod",
    successEditProduct: "Uspešno ste izmenili proizvod",
    successAddNewStore: "Uspešno ste dodali lokal",
    successEditStore: "Uspešno ste izmenili lokal",
    successDeleteProduct: "Uspešno ste obrisali proizvod",
  },
  orderGiftDialog: {
    title: "Poručivanje poklona",
    notEnoughPointsInfo: "Nažalost nemate dovoljno bodova za ovu nagradu.",
    generalInfo:
      "Na sledećoj strani možete da popunite podatke koje ćemo koristiti da vam pošaljemo odabrani poklon. Kada potvrdite, automatski će vam se oduzeti potrebni poeni za taj poklon i bićete kontaktirani u vezi sa isporukom.",
    cancel: "Otkaži",
    next: "Nastavi",
    confirm: "Potvrdi",
    orderInfoText:
      "Molimo vas da unesete tačne podatke kako bismo mogli da vas kontaktiramo i pošaljemo vam poklon.",
    name: "Ime",
    surname: "Prezime",
    phone: "Broj telefona",
    email: "Email",
    address: "Ulica i broj",
    city: "Grad",
    postOffice: "Poštanski broj",
    idNum: "Broj lične karte",
    confirmOrderingGiftTitle: "Potvrdite naručivanje poklona",
    confirmOrderingGiftExplanation:
      "Ukoliko ste sigurni da su podaci tačni, kliknite na POTVRDI kako biste poslali zahtev.",
    notInStock: "Žao nam je, ali ovaj poklon više nije dostupan!",
  },
  alertDialog: {
    confirm: "Potvrdi",
    cancel: "Otkaži",
    ok: "Ok",
  },
  giftPage: {
    youHaveTotalPoints: "Ukupno poena:",
    onStock: "{{num}} na stanju",
    infoInstallModalTitle: "Instalacija aplikacije",
    infoInstallModalSubTitle:
      "Možete instalirati ovu web aplikaciju na vašem telefonu.",
    infoInstallModalText: ` Na Android uredjajima, u Chrome pretraživaču pritisnite ikonu 'tri tačke' u 
      gornjem desnom uglu da biste otvorili meni. Izaberite 'Dodaj' na početni ekran“. 
      Pritisnite dugme Dodaj u iskačućem prozoru. Aplikacija je sada instalirana i dostupna na 
      vašem početnom ekranu.`,
    infoInstallModalText2: `Na iOS uredjajima idite do sajta ove aplikacije u Safari pretraživaču. 
    Pritisnite dugme „Deli“ (Share) i u iskačućem prozoru izaberite 
    'Dodaj na početni ekran'. Na kraju, dodirnite 'Dodaj' u 
    gornjem desnom uglu da biste završili instaliranje aplikacije. 
    Sada će biti na vašem početnom ekranu.`,
  },
  navigation: {
    profile: "Profil",
    logOut: "Log out",
    navUsers: "Korisnici",
    navSettings: "Podešavanja",
    navGifts: "Pokloni",
    navReceipts: "Obrada računa",
    reports: "Izveštaji",
    sendingGifts: "Slanje poklona",
  },
  adminUsers: {
    usersOverview: "Pregled registrovanih korisnika",
    username: "Korisničko ime",
    email: "Email",
    phone: "Telefon",
    points: "Poeni",
    verified: "Nalog verifikovan",
    userType: "Tip korisnika",
    admin: "Admin",
    regular: "Regularan",
    action: "Akcija",
    makeAdmin: "Postavi za admina",
    removeAdmin: "Skloni admin pristup",
    totalUsers: "Ukupno registrovanih korisnika: {{num}}",
  },
  adminGifts: {
    giftsOverview: "Pregled dostupnih poklona",
    available: "Dostupan",
    name: "Naziv",
    stock: "Na stanju",
    points: "Poena potrebno",
    photo: "Slika",
    actions: "Akcije",
    edit: "Izmeni",
    disable: "Onemogući",
    delete: "Obriši",
    warningDelete: "Da li ste sigurni da želite da obrišete ovaj poklon?",
    addNewGift: "Dodaj poklon",
    giftImage: "Slika poklona",
    enable: "Omogući",
  },
  adminGiftEditorModal: {
    addNewGiftTitle: "Dodajete novi poklon",
    editGiftTitle: "Menjate postojeći poklon",
    name: "Naziv",
    stock: "Komada na stanju",
    points: "Poena potrebno za osvajanje",
    photo: "Slika poklona",
    cancel: "Otkaži",
    confirm: "Dodaj",
    save: "Sačuvaj",
  },
  receiptsProcessing: {
    title: "Obrada pristiglih slika računa od korisnika",
    sortedDataInfo: "Sortirano od najstarijeg datuma radi što brže obrade",
    processed: "Obradjeni",
    unProcessed: "Neobradjeni",
    id: "ID",
    processedReceipt: "Obradjen",
    username: "Korisnik",
    createdAt: "Datum kreiranja",
    picture: "Slika računa",
    process: "Obradi",
    preview: "Pogledaj",
    valid: "Validan",
  },
  processReceiptModal: {
    title: "Obrada računa",
    reviewReceipt: "Pregled obradjenog računa",
    processReceiptHint:
      "Pažljivo pogledajte račun i uočite artikle i njihove količine, a zatim ih unesite uz pomoć forme ispod. Ukoliko ne postoji mesto prodaje sa računa u polju 'Lokacija' ili ne postoje proizvodi sa računa u polju 'Proizvod' - račun nije validan i to možete obeležiti na formi. Takodje, račun nije validan ako datum izdavanja računa nije u propisanom vremenskom opsegu.",
    user: "Korisnik: {{name}}",
    store: "Lokacija",
    pib: "PIB",
    city: "Grad",
    invoiceNumber: "Broj računa (PFR broj računa)",
    article: "Proizvod",
    articleWithNum: "{{num}}) Proizvod",
    qty: "Količina",
    price: "Cena",
    invalidReceipt: "Račun nije validan",
    totalPoints: "Ukupno poena: {{totalPoints}}",
    cancel: "Otkaži",
    save: "Sačuvaj",
    preview: "Pogledaj",
    chooseLocation: "Izaberite lokal za koji želite izveštaj:",
    chooseDatePeriod: "Izaberite period za koji zelite izveštaj:",
    noData: "Nema podataka za ovaj upit",
    totalItemsSold: "Ukupan broj prodatih artikala od početka",
  },
  adminSettings: {
    title: "Podešavanje dostupnih proizvoda i lokala",
    articleSetting: "Podešavanje artikala",
    storeSetting: "Podešavanje lokala",
    name: "Naziv",
    points: "Poeni",
    alias: "Alijasi",
    picture: "Slika",
    edit: "Izmeni",
    delete: "Obriši",
    actions: "Akcije",
    addNewArticle: "Dodaj produkt",
    deleteProductWarning:
      "Da li ste sigurni da želite da obrišete ovaj proizvod?",
  },
  addEditProductModal: {
    addNewProductTitle: "Dodajete novi proizvod",
    editProductTitle: "Menjate postojeći proizvod",
    name: "Naziv",
    points: "Poeni",
    aliases:
      "Alijasi (alijase upisujete odvojene zarezom, npr: voda, rosa, negazirana",
    picture: "Slika",
    actions: "Akcije",
    cancel: "Otkaži",
    save: "Sačuvaj",
    productImage: "Slika proizvoda",
  },
  adminSettingStore: {
    name: "Ime",
    pib: "PIB",
    productDictionary: "Alijasi proizvoda",
    actions: "Akcije",
    edit: "Izmeni",
    delete: "Obriši",
    createStore: "Kreiraj lokal",
    deleteStoreWarning: "Da li ste sigurni da żelite da obrišete ovaj lokal?",
  },
  addEditStoreModal: {
    addStoreTitle: "Kreiranje lokala",
    editStoreTitle: "Izmena postojećeg lokala",
    name: "Ime lokala",
    pib: "PIB",
    aliases: "Alijasi",
    cancel: "Otkaži",
    save: "Sačuvaj",
    definingAlias:
      "Ovde možete definisati alijase (alternativne nazive proizvoda) za svaki proizvod u lokalu (koji je dozvoljen). Artikle birate iz padajućeg menija a alijase odvajate zarezom.",
  },
  adminPrizeHistory: {
    title: "Lista naručenih poklona",
    id: "Id",
    createdAt: "Datum naručivanja",
    prize: "Poklon",
    userInfo: "Informacije o korisniku",
    name: "Ime",
    surname: "Prezime",
    idNum: "Broj lične karte",
    email: "Email",
    phoneNumber: "Telefon",
    address: "Ulica i broj",
    city: "Grad",
    exportExcel: "Eksportuj u excel",
    username: "Korisničko ime",
  },
  rulesDialog: {
    rulesTitle: "Coke Loyalty pravilnik",
  },
  instructionAlertModal: {
    title: "Dobrodošli u Coke loyalty aplikaciju",
    subtitle:
      "Ova mobilna aplikacija je kreirana kako bi vam omogućila da iskoristite svoje bodove na jednostavan način. Imate tri ekrana na raspolaganju, i to:",
    text1:
      "Ekrana sa poklonima - na ovom ekranu možete odabrati poklon koji želite da naručite ukoliko imate dovoljno bodova i ako je isti na stanju. Izbor je raznovrstan i uključuje različite artikle koji su dostupni u skladu sa brojem bodova koje imate.",
    text2:
      "Ekrana za skeniranje fiskalnih računa - na ovom ekranu možete skenirati fiskalni račun iz određenih kafića ili poslati sliku računa. Na taj način ćete prikupljati bodove koje kasnije možete iskoristiti za naručivanje poklona.",
    text3:
      "Ekrana sa bodovima - ovaj ekran vam pokazuje koliko bodova imate i koji artikli su uključeni u promociju i koliko bodova donose.",
    text4:
      "Nadamo se da će vam ova aplikacija biti od koristi i da ćete uživati u korišćenju. Ukoliko imate neka pitanja ili nedoumice, obratite se našem korisničkom servisu koji vam stoji na raspolaganju (informacije na profilnoj strani). Hvala vam što koristite našu aplikaciju!",
    text5:
      "Ovaj dialog moguće je ponovo pokrenuti na početnoj strani (pokloni), gornji levi ugao info ikonica.",
  },
  lastDayAlert: {
    title: "Poslednji dan nagradne igre",
    content: "23.5.2023. je poslednji dan kada možete da skenirate račune i naručujete poklone.",
    doNotShowAlert: "Ne prikazuj više"
  },
  endGame: {
    title: "Nagradna igra je završena",
    content: "Ne možete više slati račune, ali možete naručivati nagrade ukoliko imate dovoljan broj bodova",
    backToGifts: "Nazad na nagrade"
  }
};
